import { CardHeaderBody } from "./card-header-body";

export class CardBodyDetails {
    cardBodyTitle: string;
    cardBodyParam1: string;
    cardBodyParam2: string;

    constructor(cardBodyTitle: string, cardBodyParam1: string, cardBodyParam2: string){

        this.cardBodyTitle = cardBodyTitle,
        this.cardBodyParam1 = cardBodyParam1,
        this.cardBodyParam2 = cardBodyParam2
    }
}